export const NOTIFICATIONS_READ = "NOTIFICATIONS_READ";
export const NOTIFICATIONS_MARK_AS_READ = "NOTIFICATIONS_MARK_AS_READ";
export const NOTIFICATIONS_READED = "NOTIFICATIONS_READED";
export const NOTIFICATIONS_SENT_BY_ME = "NOTIFICATIONS_SENT_BY_ME";
